<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="ongoingObjectives && ongoingObjectives.length"
      class="flex break-inside-avoid flex-col"
    >
      <h4 class="text-title-medium">
        {{ $t('objective.ongoing') }}
      </h4>
      <ul class="grid grid-cols-2 gap-4">
        <li v-for="objective in ongoingObjectives" :key="objective.id">
          <PrintObjectiveItem :objective="objective" />
        </li>
      </ul>
    </div>
    <div
      v-if="createdObjectives && createdObjectives.length"
      class="flex break-inside-avoid flex-col"
    >
      <h4 class="text-title-medium">
        {{ $t('objective.created') }}
      </h4>
      <ul class="grid grid-cols-2 gap-4">
        <li v-for="objective in createdObjectives" :key="objective.id">
          <PrintObjectiveItem :objective="objective" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import type { Objective } from '@/core/composables/use-objectives'
  import PrintObjectiveItem from './PrintObjectiveItem.vue'

  interface Props {
    createdObjectives: ReadonlyArray<Objective>
    ongoingObjectives: ReadonlyArray<Objective>
  }

  defineProps<Props>()
</script>
